module.exports = __webpack_public_path__ + "img/2.6-花市酸枣王（杨树田-摄）.b48b9433.jpg";